import React, { useRef } from 'react'
import { Table } from './Table'
import { IProps } from './Filter'
import { IPermissionProps } from '../../models/Login';




export const NonPerformingPvAllocation = (permissions: IPermissionProps) => {
  const toast = useRef<any>(null);

  return (
    <>
      {permissions.is_View && <Table toast={toast}/>}
    </>
  )
}